import { useMutation } from "react-query";
import { reactQueryPost } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";

interface CreateLiveChatMessageSuccessResponse {
  result: {
    session_id: string;
  };
}

interface CreateLiveChatMessageErrorResponse {
  result: {
    error: "chat_closed";
    opening_time?: string;
    closing_time?: string;
  };
}

type CreateLiveChatMessageResponse =
  | CreateLiveChatMessageSuccessResponse
  | CreateLiveChatMessageErrorResponse;

interface UseCreateLiveChatProps {
  onError?: (error: Error) => void;
  onSuccess?: (data: CreateLiveChatMessageResponse) => void;
}

interface CreateLiveChatParams {
  conversationId: string | null;
}

export const useCreateLiveChat = ({
  onSuccess,
  onError,
}: UseCreateLiveChatProps = {}) =>
  useMutation<CreateLiveChatMessageResponse, Error, CreateLiveChatParams>({
    mutationFn: async ({ conversationId }: CreateLiveChatParams) =>
      reactQueryPost<CreateLiveChatMessageResponse>(
        internalApi.helpWidget.createLiveChat(),
        {
          conversation_id: conversationId,
        },
      ),
    onSuccess,
    onError,
  });
